// extracted by mini-css-extract-plugin
export default {"card":"IndicadorForm_card__AgSNp","buttonStatus":"IndicadorForm_buttonStatus__KKfs3","header":"IndicadorForm_header__ooeUF"};